import { Box, Button } from "@chakra-ui/react";
import InputField from "components/fields/InputField";

type Props = {
  showFilters: boolean;
  isLoading: boolean;
  filters: any;
  setFilters: any;
  handleSearchSubmit(): void;
  handleSearchClear(): void;
};

const FeeGroupAgentSearch = (props: Props) => {
  const {
    showFilters,
    isLoading,
    filters,
    setFilters,
    handleSearchSubmit,
    handleSearchClear,
  } = props;

  if (!showFilters) return null;

  const handleInputChange = async (event: any) => {
    const { id, value } = event.target;
    setFilters({ ...filters, [id]: value });
  };

  return (
    <Box className="mb-4 mt-2 rounded-lg bg-white p-6 shadow-lg ring-1 ring-gray-100">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="tracking-tight text-gray-900">
          <InputField
            id="name"
            label="Name"
            placeholder="Search by fee group name"
            disabled={isLoading}
            variant="auth"
            extra="shadow-sm"
            type="text"
            autoComplete="off"
            value={filters.name}
            onChange={handleInputChange}
          />
        </div>

        <div className="flex flex-1 items-end justify-end gap-2 pt-2">
          <Button
            isDisabled={isLoading}
            onClick={() => handleSearchClear()}
            className="px-4 py-2.5 text-sm font-medium text-gray-600 hover:text-gray-700"
          >
            Clear
          </Button>

          <Button
            isDisabled={isLoading}
            onClick={() => handleSearchSubmit()}
            className="btn-primary relative overflow-hidden rounded-md px-6 py-2.5 text-sm font-medium text-white shadow-md transition-colors duration-300 hover:bg-primary-500 active:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <span className="relative z-10 tracking-tight">
              Search Fee Group
            </span>
          </Button>
        </div>
      </div>
    </Box>
  );
};

export default FeeGroupAgentSearch;
